import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import EditIcon from '@mui/icons-material/Edit';
import Divider from '@mui/material/Divider';
import ArchiveIcon from '@mui/icons-material/Archive';
import FileCopyIcon from '@mui/icons-material/FileCopy';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Block, Delete, MoreVert, PictureAsPdf, SaveAs, SendAndArchive } from '@mui/icons-material';
import { ListItemIcon, ListSubheader } from '@mui/material';
import { CatalogInitNumberDialog } from '../../modals/CatalogInitNumberDialog';
import { MatchInitWizardDialog } from '../../modals/MatchInitWizard';
import { CowSqualifiedDialog } from '../../modals/CowSqualifiedDialog';
import { ExportDataDialog } from '../../modals/ExportDataDialog';

const StyledMenu = styled((props) => (
    <Menu
        elevation={0}
        anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
        }}
        transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
        }}
        {...props}
    />
))(({ theme }) => ({
    '& .MuiPaper-root': {
        borderRadius: 6,
        marginTop: theme.spacing(1),
        minWidth: 180,
        color: 'rgb(55, 65, 81)',
        boxShadow:
            'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
        '& .MuiMenu-list': {
            padding: '4px 0',
        },
        '& .MuiMenuItem-root': {
            '& .MuiSvgIcon-root': {
                fontSize: 18,
                color: theme.palette.text.secondary,
                marginRight: theme.spacing(1.5),
            },
            '&:active': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    theme.palette.action.selectedOpacity,
                ),
            },
        },
        ...theme.applyStyles('dark', {
            color: theme.palette.grey[300],
        }),
    },
}));

export default function MatchpageMenu({ show, handleClean, handleExport, handlePdf, ExportCSV, category_list }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };



    return (
        <div>
            <Button
                id="cow-button"
                aria-controls={open ? 'cow-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant={open ? 'contained' : "outlined"}
                disableElevation
                onClick={handleClick}

            >
                <MoreVert />
            </Button>
            <StyledMenu
                id="cow-menu"
                MenuListProps={{
                    'aria-labelledby': 'cow-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <ListSubheader>stampa PDF</ListSubheader>
                <MenuItem disabled={!show} onClick={() => { handlePdf('p'); handleClose() }} disableRipple>
                    <ListItemIcon>
                        <PictureAsPdf />
                    </ListItemIcon>
                    Documenti gare
                </MenuItem>
                <Divider />
                <ListSubheader>esportazione dati </ListSubheader>
                <MenuItem onClick={() => { handleExport(); handleClose() }} disableRipple>
                    <ListItemIcon>
                        <SendAndArchive />
                    </ListItemIcon>
                    Esporta dati
                </MenuItem>
{/*                 <MenuItem onClick={() => { handleExport('unix'); handleClose() }} disableRipple>
                    <ListItemIcon>
                        <SaveAs />
                    </ListItemIcon>
                    Esporta TXT dati gare Database [unix]
                </MenuItem>
                <MenuItem onClick={() => { handleExport('dos'); handleClose() }} disableRipple>
                    <ListItemIcon>
                        <SaveAs />
                    </ListItemIcon>
                    Esporta TXT dati gare Database [dos]
                </MenuItem>
                <ExportCSV /> */}
                <Divider />
                <ListSubheader>gestione gare</ListSubheader>
                <MatchInitWizardDialog category_list={category_list} closeMenu={handleClose} />
                {/*                 <MenuItem onClick={() => { handleSqualified(); handleClose() }} disableRipple>
                    <ListItemIcon>
                        <Block />
                    </ListItemIcon>
                    Squalifica soggetto
                </MenuItem> */}
                <Divider />
                <MenuItem disabled={!show} onClick={() => { handleClean(); handleClose() }} disableRipple>
                    <ListItemIcon>
                        <Delete />
                    </ListItemIcon>
                    Elimina tutte le gare
                </MenuItem>
            </StyledMenu>
        </div>
    );
}